import styled from 'styled-components';
import { palette } from '@dev/ee-components';

export const SimplePopoverWrapper = styled.div`
    margin-bottom: 20px;
`;

export const AdditionalDescWrapper = styled.div`
    margin-bottom: 20px;
`;

export const AlertWrapper = styled.div`
    display: flex;
    margin-bottom: 16px;
    svg {
        margin-right: 16px;
    }
`;

export const AdditionalValueLength = styled.span`
    grid-area: d;
    display: flex;
    justify-content: end;
    color: ${palette.gray[5]};
`;
